var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "checkbox-wrapper" }, [
        _c("input", {
          staticClass: "screen-reader",
          attrs: {
            id: _vm.id,
            name: _vm.id,
            "aria-label": `${_vm.label} ${
              _vm.price ? _vm.showPrice(_vm.price.trim()) : ""
            }`,
            type: "checkbox",
          },
          on: {
            click: function ($event) {
              return _vm.$emit("input", {
                optionId: _vm.id,
                optionName: _vm.label,
                price: _vm.price,
              })
            },
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.$emit("input", {
                optionId: _vm.id,
                optionName: _vm.label,
                price: _vm.price,
              })
            },
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            class: ["checkbox-label", { isSelected: _vm.value }],
            attrs: { for: _vm.id },
          },
          [
            _c("div", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.value,
                  expression: "value",
                },
              ],
              staticClass: "checkbox-checked-icon",
            }),
            _vm._v(" "),
            _vm.isAlcohol
              ? _c("img", {
                  staticClass: "icon",
                  staticStyle: {
                    height: "auto",
                    width: "15px",
                    "margin-right": "5px",
                  },
                  attrs: {
                    src: _vm.$CDN + "/images/alcohol.svg",
                    loading: "lazy",
                    title: "Alcohol",
                    alt: "Alcohol icon",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "label-wrapper" }, [
              _c("span", [_vm._v(_vm._s(_vm.label))]),
              _vm._v(" "),
              _vm.hasNestedOptions &&
              !Object.keys(_vm.getNestedOptionsSelected).length
                ? _c("i", {
                    staticClass: "fas fa-chevron-right has-nested-indicator",
                  })
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.price
              ? _c("span", [
                  _vm._v(" " + _vm._s(_vm.showPrice(_vm.price.trim()))),
                ])
              : _c("span", [_vm._v(" ")]),
          ]
        ),
      ]),
      _vm._v(" "),
      Object.keys(_vm.getNestedOptionsSelected).length
        ? _c("nested-selections", {
            attrs: {
              nestedSelections: _vm.getNestedOptionsSelected,
              parentLabel: _vm.label,
            },
            on: {
              editNestedSelections: function ($event) {
                return _vm.$emit("editNestedSelections", _vm.id)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }